// The pengecekan / audit page a problem came from ("Lihat Cek").
// null when the problem has none: it was added by hand, or the checklist row it pointed to no longer exists.
//   kind: "pengecekan" | "audit", id: pemakaian_mobil_id / audit_kendaraan_id
export const getProblemSource = (problem) => {
  const pemakaianMobilId =
    problem?.data_pengecekan_mobil_detil?.data_pengecekan_mobil
      ?.pemakaian_mobil_id;
  if (pemakaianMobilId > 0) return { kind: "pengecekan", id: pemakaianMobilId };

  const auditKendaraanId = problem?.data_audit_kendaraan_detil?.audit_kendaraan_id;
  if (auditKendaraanId > 0) return { kind: "audit", id: auditKendaraanId };

  return null;
};

export const hasProblemSource = (problem) => !!getProblemSource(problem);

export const noProblemSourceTitle = "Problem ini tidak punya data pengecekan asal";
